<template>
  <div
    class="add-bank-list"
    :class="{ 'add-bank-default': item.defaultState == 1 }"
  >
    <div class="left">
      <div class="left-top">
        <div class="bank-logo">
          <img
            :src="`${require(`@/assets/style/bankLogo/${item.bankName}.png`)}`"
            alt=""
          />
        </div>
        <span :class="{ span: item.defaultState == 1 }">{{
          item.bankName
        }}</span>
      </div>
      <div
        class="left-bottom"
        :class="{ 'left-bottom-default': item.defaultState == 1 }"
      >
        {{ formatBankNumCard(item.bankNumber) }}
      </div>
    </div>
    <div class="default" v-if="item.defaultState == 1">
      <span>默认卡</span>
    </div>
    <div class="right-set" v-else @click="handleSetDefaultBankCard(item)">
      <img src="@/assets/style/switch-on.png" alt="" />
      <span>设为默认卡</span>
    </div>
  </div>
</template>

<script>
import { setDefaultBankCard } from "@/api/index.js";
import { formatBankNumCard } from "@/utils/utils.js";
export default {
  name: "addBankList",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formatBankNumCard,
    };
  },
  methods: {
    handleSetDefaultBankCard(item) {
      setDefaultBankCard({ bankId: item.id }).then((res) => {
        if (res.code == 2000) {
          this.$toast("设为默认卡成功");
          this.$emit("setDefaultBankCardSuccess", item.id);
        } else {
          this.$toast("设为默认卡失败");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.add-bank-list {
  height: 66px;
  padding: 19px 16px 16px 16px;
  background-image: url("@/assets/style/selectList-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  color: #333333;
  position: relative;
}
.add-bank-default {
  background-image: url("@/assets/style/default-bj.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #fff;
}
.left {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  .left-top {
    display: flex;
    align-items: center;
    .bank-logo {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      margin-right: 8px;
      border-radius: 50%;
      img {
        width: 26px;
        height: 26px;
      }
    }
  }
  .left-bottom {
    font-size: 18px;
  }
  .left-bottom-default {
    font-size: 18px;
  }
}
.right {
  font-size: 14px;
  border: solid 1px #fff;
  padding: 2px 16px;
  border-radius: 12px;
  opacity: 0.7;
}
.right-set {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  align-items: center;
  img {
    width: 40px;
    margin-bottom: 4px;
  }
}
.default {
  position: absolute;
  top: 0;
  right: 0;
  background-image: url("@/assets/style/overdue-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 3px 8px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC;
}
</style>
